import "@orestbida/iframemanager";

export function initIframeCookies() {
	const im = iframemanager();
	const language = document.documentElement.getAttribute('lang');

	im.run({
		currLang: language,
		services : {
			googlemaps : {
				embedUrl: 'https://www.google.com/maps/embed?pb={data-id}',

				iframe: {
					allow : 'picture-in-picture; fullscreen;'
				},

				languages : {
					cz : {
						notice: 'Mapa pochází od třetí strany. Zobrazením této mapy souhlasíte s <a rel="noreferrer noopener" href="https://cloud.google.com/maps-platform/terms" target="_blank">obchodními podmínkami</a> služby Google Maps.',
						loadBtn: 'Načíst mapu',
						loadAllBtn: 'Načíst mapu trvale'
					},
					en : {
						notice: 'The map comes from a third party. By displaying this map, you agree to the Google Maps <a rel="noreferrer noopener" href="https://cloud.google.com/maps-platform/terms" target="_blank">terms of service</a>.',
						loadBtn: 'Load map',
						loadAllBtn: 'Load map permanently'
					},
					de : {
						notice: 'Die Karte stammt von einem Drittanbieter. Durch die Anzeige dieser Karte stimmen Sie den <a rel="noreferrer noopener" href="https://cloud.google.com/maps-platform/terms" target="_blank">Nutzungsbedingungen</a> von Google Maps zu.',
						loadBtn: 'Karte laden',
						loadAllBtn: 'Karte dauerhaft laden'
					}
				}
			}
		}
	});
}
